{
  "name": "se-store-ui",
  "version": "1.1.0",
  "private": true,
  "license": "MIT",
  "scripts": {
    "build": "ng build",
    "build:ci": "ng build --configuration=ci",
    "coverage": "ng test --no-watch --code-coverage",
    "dev": "ng serve --host se-store-ui.sportngin.com.dev --configuration=development",
    "dev-staging": "ng serve --host se-store-ui.sportngin.com.dev --configuration=dev-staging",
    "fix": "ng lint --fix",
    "lint": "ng lint",
    "setup": "yarn install --immutable",
    "setup:ci": "yarn install --immutable",
    "start": "ng serve",
    "test": "ng test --no-watch",
    "test:ci": "ng test --karma-config=src/karma.conf.js --code-coverage --no-watch",
    "ui:tests:auth": "cross-env AWS_PROFILE=se-staging gimme-aws-creds --profile=se-staging",
    "ui:tests:open:local": "bash ./e2e-tests/scripts/set-env.sh development && playwright test --ui",
    "ui:tests:open:production": "bash ./e2e-tests/scripts/set-env.sh production && playwright test --ui",
    "ui:tests:open:staging": "bash ./e2e-tests/scripts/set-env.sh staging && playwright test --ui",
    "ui:tests:run:local": "bash ./e2e-tests/scripts/set-env.sh development && playwright test",
    "ui:tests:run:pr": "bash ./e2e-tests/scripts/set-env.sh pull-request && playwright test",
    "ui:tests:run:production": "bash ./e2e-tests/scripts/set-env.sh production && playwright test",
    "ui:tests:run:staging": "bash ./e2e-tests/scripts/set-env.sh staging && playwright test",
    "ui:tests:setup:local": "yarn ui:tests:setup:staging",
    "ui:tests:setup:pr": "yarn ui:tests:setup:staging",
    "ui:tests:setup:production": "yarn playwright install && aws ssm get-parameters --names /se-store-ui/ui-tests/production --region us-east-1 --with-decryption --query \"Parameters[].Value\" --output text  > .env",
    "ui:tests:setup:staging": "yarn playwright install && aws ssm get-parameters --names /se-store-ui/ui-tests/staging --region us-east-1 --with-decryption --query \"Parameters[].Value\" --output text > .env"
  },
  "resolutions": {
    "flatted": "^3.4.2",
    "node-forge": "^1.3.0",
    "tar": "^6.2.1"
  },
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@datadog/browser-logs": "^7.16.2",
    "@ngrx/effects": "^22.0.1",
    "@ngrx/router-store": "^22.0.1",
    "@ngrx/store": "^22.0.1",
    "@ngrx/store-devtools": "^22.0.1",
    "@ngx-translate/core": "^17.0.0",
    "file-saver": "^2.0.5",
    "http-status-codes": "~2.3.0",
    "luxon": "^3.7.2",
    "rxjs": "~7.8.2",
    "sass": "^1.106.1",
    "se-analytics": "^4.1.1",
    "se-analytics-js": "^1.2.3",
    "se-fe-alert": "^13.0.0",
    "se-fe-api": "^12.0.0",
    "se-fe-button": "^13.0.0",
    "se-fe-card": "^14.0.0",
    "se-fe-chip": "^14.0.0",
    "se-fe-confirm": "^12.0.0",
    "se-fe-datepicker": "^16.0.0",
    "se-fe-domain-environment": "^11.0.0",
    "se-fe-empty-state": "^13.0.0",
    "se-fe-form-control-help": "^9.0.0",
    "se-fe-form-field": "^13.0.0",
    "se-fe-form-field-options": "^14.0.0",
    "se-fe-form-field-suffix": "^13.0.0",
    "se-fe-form-field-text": "^13.0.0",
    "se-fe-form-service": "^11.0.0",
    "se-fe-frame-router": "^12.0.0",
    "se-fe-grid": "^14.0.0",
    "se-fe-header": "^14.0.0",
    "se-fe-icon": "^13.0.0",
    "se-fe-indicator-dot": "^12.0.0",
    "se-fe-inline-list": "^12.0.0",
    "se-fe-link": "^14.0.0",
    "se-fe-menu": "^17.0.0",
    "se-fe-modal": "^17.0.0",
    "se-fe-overlay": "^12.0.0",
    "se-fe-page": "^14.0.0",
    "se-fe-pagination": "^14.0.0",
    "se-fe-position": "^11.0.0",
    "se-fe-progress-bar": "^14.0.0",
    "se-fe-scroll": "^11.0.0",
    "se-fe-service": "^12.0.0",
    "se-fe-spinner": "^13.0.0",
    "se-fe-table": "^16.0.0",
    "se-fe-tabs": "^14.0.0",
    "se-fe-test-id": "^4.0.0",
    "se-fe-themes": "^13.0.0",
    "se-fe-toast": "^15.0.0",
    "se-fe-toolbar": "^13.0.0",
    "se-fe-tooltip": "^15.0.0",
    "se-fe-translations": "^11.0.0",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/core": "^22.2.5",
    "@angular-eslint/builder": "^22.6.0",
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/language-service": "^22.2.3",
    "@faker-js/faker": "^10.6.0",
    "@playwright/test": "^1.64.1",
    "@sportngin/qa-automation-package": "2.4.1",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.15",
    "@types/luxon": "^3.7.6",
    "@types/node": "^24.19.2",
    "angular-eslint": "^22.6.0",
    "cross-env": "^10.1.0",
    "dayjs": "^1.11.23",
    "dotenv": "18.0.9",
    "eslint": "^10.13.0",
    "eslint-plugin-jsdoc": "^65.4.2",
    "jasmine-core": "~5.3.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.3.0",
    "karma-spec-reporter": "^0.0.37",
    "ts-deepmerge": "^7.0.3",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.72.1"
  },
  "packageManager": "yarn@4.18.0",
  "engines": {
    "node": ">=24.15.0 <25"
  }
}
